export function sidesFor(players: string[], mode: "singles" | "doubles") {
  return mode === "doubles"
    ? { side1: players.slice(0, 2), side2: players.slice(2, 4) }
    : { side1: players.slice(0, 1), side2: players.slice(1, 2) };
}
